import { render, staticRenderFns } from "./CapillaryLocations.vue?vue&type=template&id=50ae13f7"
import script from "./CapillaryLocations.vue?vue&type=script&lang=js"
export * from "./CapillaryLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports